import React, { useEffect, useState } from "react";
import { storeApi } from "@/lib/storeApi";
import { pixel } from "@/lib/metaPixel";
import { SourcePicker } from "@/components/SourcePicker";

let cached = null;
export function useSalesOpen() {
  const [open, setOpen] = useState(cached);
  useEffect(() => {
    if (cached !== null) return;
    storeApi.get("/store/status").then((r) => { cached = !!r.data.sales_open; setOpen(cached); }).catch(() => setOpen(false));
  }, []);
  return open;
}

export default function LaunchNotify({ defaultEmail = "", compact = false, testid = "launch-notify" }) {
  const [email, setEmail] = useState(defaultEmail);
  const [sources, setSources] = useState([]);
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(false);
  const [err, setErr] = useState("");
  const submit = async (e) => {
    e.preventDefault();
    if (busy || done) return;
    setBusy(true); setErr("");
    try {
      await storeApi.post("/store/waitlist", { channel: "mt5_launch", email, sources });
      pixel.lead("mt5_launch");
      localStorage.setItem("bgx_waitlist_joined", "1");
      setDone(true);
    } catch (ex) { setErr(ex?.response?.data?.detail || "Couldn't add you - please check the email and try again."); }
    setBusy(false);
  };
  return (
    <div data-testid={testid} className={`rounded-2xl border border-[#FBBF24]/50 bg-[#050914]/80 ${compact ? "p-5" : "p-7"}`}>
      <div className="mono text-[10px] uppercase tracking-[0.3em] text-[#FBBF24]">Launching very soon</div>
      <div className={`${compact ? "text-xl" : "text-2xl sm:text-3xl"} font-medium mt-2`}>Get notified the moment the store opens</div>
      <p className="text-sm text-[#94A3B8] mt-2 max-w-xl">
        Subscriptions aren't open just yet - I'm finalising the last few bits. Pop your email in and I'll send you a confirmation email
        as soon as everything is live, so you can be first to pick your bots.
      </p>
      {done ? (
        <div data-testid={`${testid}-done`} className="mt-5 text-[#34D399] text-sm font-semibold">
          You're on the list. Keep an eye on your inbox - I'll email you as soon as BotGenomix goes live.
        </div>
      ) : (
        <form onSubmit={submit} className="mt-5 flex flex-col gap-2">
          <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} placeholder="you@email.com"
            data-testid={`${testid}-email`} className="flex-1 bg-[#0B1220] border border-blue-900/60 rounded-lg px-4 py-3 text-sm focus:border-[#FBBF24] outline-none" />
          <SourcePicker value={sources} onChange={setSources} testid={`${testid}-source`} />
          <button disabled={busy} data-testid={`${testid}-submit`}
            className="sm:self-start mt-1 mono text-[11px] uppercase tracking-widest px-6 py-3 rounded-lg bg-[#FBBF24] text-[#050914] font-semibold hover:bg-[#FDE68A] disabled:opacity-50">
            {busy ? "Adding…" : "Notify me at launch"}
          </button>
        </form>
      )}
      {err && <div data-testid={`${testid}-error`} className="mt-2 text-xs text-[#F87171]">{err}</div>}
      <div className="text-[11px] text-[#64748B] mt-3">One email when we launch, plus occasional updates. Unsubscribe any time.</div>
    </div>
  );
}
